/**
 * Device that opened this Realtime Database presence connection.
 */
export enum UserPresenceConnectionDeviceType {
  desktop = 'desktop',
  phone = 'phone',
}
